export const DEFAULT_DROPDOWN = {
    input: () => {
        //
    },
    isScrollable: true,
    items: ['Items should not be empty'],
    name: '',
    reset: () => {
        //
    },
    size: 'medium',
    title: '',
    theme: 'light',
    value: '',
};
export const DEFAULT_SEARCH = {
    input: () => {
        //
    },
    reset: () => {
        //
    },
    placeholder: 'Поиск',
    value: '',
};
